import { createSlice } from '@reduxjs/toolkit';

// Slice
const slice = createSlice({
  name: 'onlineUsers',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    setOnlineUsers(state, action) {
      state.data = action.payload;
      state.status = 'succeeded';
    },
    setUserOnline(state, action) {
      state.data.push(action.payload);
    },
    setUserOffline(state, action) {
      const thirtyMinutesAgo = new Date(Date.now() - 30 * 60 * 1000); // 30 minutes ago in milliseconds
      state.data = state.data.filter(
        ({ userId, lastSeen }) => (
          userId !== action?.payload?.userId
          && new Date(lastSeen) >= thirtyMinutesAgo
        ),
      );
    },
  },
  extraReducers: {},
});

export const { setOnlineUsers, setUserOnline, setUserOffline } = slice.actions;

export default slice.reducer;
